import { render, staticRenderFns } from "./FactoryInvoiceViewPage.vue?vue&type=template&id=53aa36ca&scoped=true&"
import script from "./FactoryInvoiceViewPage.vue?vue&type=script&lang=ts&"
export * from "./FactoryInvoiceViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./FactoryInvoiceViewPage.vue?vue&type=style&index=0&id=53aa36ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aa36ca",
  null
  
)

export default component.exports